import instance from './testing.instance';

export const getApiKeys = () => instance.get(`/external/all`);

export const createApiKey = id => instance.post(`/external/new/?jerarquia=${id}`);

export const deleteApiKey = uid => instance.delete(`/external/deprecate/?uid=${uid}`);
export const deleteAllApiKeys = () => instance.delete(`/external/clean/`);